export default __webpack_public_path__ + "static/media/delete.9d0a9f89.png";